import { clientConfig } from "../../../../config";

interface Props {
  imageSrc: string;
  title: string;
  dosage?: string | null;
  quantity?: string | null;
}

// Brand word bold, rest medium (Figma 38938:196).
const splitTitle = (title: string): [string, string] => {
  const firstSpace = title.indexOf(" ");
  return firstSpace === -1 ? [title, ""] : [title.slice(0, firstSpace), title.slice(firstSpace)];
};

const ReorderProductSummary = ({ imageSrc, title, dosage, quantity }: Props) => {
  const [brand, rest] = splitTitle(title);

  return (
    <div
      data-testid="wl-reorder-product-summary"
      className="flex w-full items-center gap-[16px] rounded-[16px] border border-solid border-[#e2e8df] bg-white p-[16px]"
    >
      <div className="relative size-[80px] shrink-0 overflow-hidden rounded-[12px] border border-solid border-[#eef1f6] bg-[#edf4f0]">
        <img src={`${clientConfig.IMAGES_URL}${imageSrc}`} alt={title} className="size-full object-cover" />
      </div>
      <div className="flex min-w-0 flex-1 flex-col">
        <p className="m-0 pt-[4px] font-poppins text-[18px] leading-[22.5px] text-[#08080a]">
          <span className="font-bold">{brand}</span>
          {rest && <span className="font-medium">{rest}</span>}
        </p>
        <div className="flex items-center gap-[8px] pt-[4px]">
          {dosage ? (
            <span className="rounded-full bg-[#edf4f0] px-[8px] py-[2px] font-roboto text-[12px] font-semibold leading-[16px] text-[#41a45f]">
              {dosage}
            </span>
          ) : null}
          {quantity ? <span className="font-roboto text-[14px] leading-[20px] text-[#6b7a68]">{quantity}</span> : null}
        </div>
      </div>
    </div>
  );
};

export default ReorderProductSummary;
